<template>
    <section class="chartlistings"
        :class="{'selection_youtube': charttype == 'yt', 'selection_soundcloud': charttype == 'sc'}">
        <article v-for="chart in charts"
            :class="{'youtube': charttype == 'yt', 'soundcloud': charttype == 'sc'}"
            :key="chart.track._id"
            class="chartlistings__list">
            <div class="chartlistings__list--trending">
                <!-- <span class="ribbon_new">New</span> -->
                <span v-if="trend(chart.track) === trending.up"><i class="fas fa-fw fa-md fa-arrow-up text-success"></i></span>
                <span v-if="trend(chart.track) === trending.down"><i class="fas fa-fw fa-md fa-arrow-down text-danger"></i></span>
                <span v-if="trend(chart.track) === trending.same"><i class="fas fa-fw fa-md fa-arrow-right text-same"></i></span>
            </div>
            <div class="chartlistings__list--position">
                <span class="current_position">{{ chart.position }}</span>
                <span class="old_position">Last Pos: <span v-if="chart.track.position_old != 0">{{ chart.track.position_old }}</span>
                <span v-if="chart.track.position_old == 0"><i class="far fa-ellipsis-h fa-fw fa-sm text-same"></i></span>
                </span>
            </div>
            <div class="chartlistings__list--artwork" @click.stop.prevent="play(chart)">
                <div class="chartlistings__list--artwork-overlay"><i class="fal fa-fw fa-2x fa-play-circle"></i></div>
                <div class="artwork_holder" :style="'background-image: url(' + chart.track.poster + ')'"></div>
            </div>
            <div class="chartlistings__list--info">
                <div class="track_meta">
                    <h4 class="track_title">{{chart.track.name}}</h4>
                    <h3 class="track_artist">{{chart.track.artist}}</h3>    
                </div>
                <div class="track_info">
                    <a v-if="chart.track.type === 'sc'"  :href="chart.track.url" target="_blank" rel="nofollow" class="track_info--network soundcloud"><i class="far fa-external-link-alt fa-fw fa-md mr-1"></i>
                    </a>
                    <a v-if="chart.track.type === 'yt'"  :href="chart.track.url" target="_blank" rel="nofollow" class="track_info--network youtube"><i class="far fa-external-link-alt fa-fw fa-sm mr-1"></i>
                    </a>
                </div>
            </div>

            <div class="chartlistings__list--ribbon" :class="{'currently__playing--soundcloud': chart.type == 'sc', 'currently__playing--youtube': chart.type == 'yt', 'currently__playing' : chart.track.active}"></div>

            <div class="chartlistings__list--mediaplayer" :class="{'mediaplayer--sc' : chart.type == 'sc', 'mediaplayer--yt' : chart.type == 'yt'}" v-if="chart.track.active">
                <!--
                    Media Player
                -->
                <div @click.stop.prevent="chart.track.active = !chart.track.active" class="chart__control--close d-flex justify-content-between align-items-center">
                    <span><i class="fal fa-lg fa-times"></i></span>
                </div>

                <div class="d-flex justify-content-center align-items-center card__chart--embed" v-html="chart.track.embed"></div><!--// media player -->
            </div>
        </article>
        <!-- <div class="row col-md-12 action-holder justify-content-center">
            <button v-if="isLoadMore" @click.prevent.stop="more()" type="button" class="btn btn-secondary btn-lg active" autocomplete="off">
                <span v-if="!isLoading">Load more</span>
                <span v-if="isLoading"><i class="far fa-2x fa-spin fa-circle-notch"></i></span>
            </button>
        </div> -->
    </section>
</template>

<script>
    export default {
        mounted() {
            this.fetch();
        },
        props: ['charttype'],
        data(){
            return{
                data : [],
                isLoading: false,
                charts: [],
                trending: {
                    'up'   : 'UP',
                    'down' : 'DOWN',
                    'SAME' : 'SAME'
                }

            }
        },

        computed: {
            isLoadMore(){
                return (this.data.next_page_url) ? true : false;
            }
        },

        methods: {

            trend(track)
            {
                if(typeof track === 'object')
                {
                    if(parseInt(track.position_old) == 0 )
                    {
                        return this.trending.up;
                    }

                    if(parseInt(track.position) == parseInt(track.position_old) )
                    {
                        return this.trending.same;
                    }

                    if(parseInt(track.position) > parseInt(track.position_old))
                    {
                        return this.trending.down;
                    }

                    if(parseInt(track.position) < parseInt(track.position_old))
                    {
                        return this.trending.up;
                    }
                }
            },

            fetch(){
                this.isLoading = true;
                axios.get(`/api/charts?type=${this.charttype}`).then( (rs) => {
                    if(typeof rs.data === 'object')
                    {
                        this.data = rs.data;
                        this.charts = rs.data.data;
                        this.isLoading = false;
                    }
                }).catch( (err) => {

                });
            },

            play(chart){
                _.each(this.charts, (d) => {
                    d.track.active = false;
                });

                chart.track.active = true;
                this.$forceUpdate();
            },

            more(){
                this.isLoading = true;
                const uri = `/api/charts?type=${this.charttype}&page=${this.data.current_page + 1}`;
                axios.get(uri).then( (rs) => {
                    if(typeof rs.data === 'object')
                    {
                        this.data = rs.data;
                        _.each( rs.data.data, d => this.charts.push( d ) );
                        this.isLoading = false;
                    }
                }).catch( (err) => {

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ChartList.vue